import { ContentTopBar } from 'components'
import { UploadDetailsTable } from 'features/transaction_list/component/upload-deatils-list-tabel/upload-details-list-UploadDetails-table';
import { useGetUploadDetails } from 'features/transaction_list/use-cases/get-upload-details';
import { usePaginationParams } from 'hooks';
import { useEffect } from 'react';
import { useLocation, useParams, useSearchParams } from 'react-router-dom';

const UploadListDetails = () => {
    const location = useLocation();
    const { id } = useParams();
    const params1 = new URLSearchParams(location.search);

    const eventId = params1.get("eventId");
    const { params, updateParams } =
        usePaginationParams<any>({
            id: id,
            eventId: eventId,
            page: 1,
            size: 10,
        });

    useEffect(() => {
        updateParams({
            id: id,
            eventId: eventId,
        });
    }, [id, eventId]);

    const [searchParams] = useSearchParams();
    const origin = searchParams.get("origin") || "";
    const isBulkUpload =
        origin.toLowerCase() === "bulkupload"

    const originType = isBulkUpload ? "bulkupload" : "groupregistration";

    const { data, isFetching, refetch } = useGetUploadDetails(
        params,          
        originType,      
        { retry: false } 
    );

    const updatedTitle: string = isBulkUpload
        ? "Bulk Upload"
        : "Group Registration";


    return (
        <>

            <ContentTopBar
                title={`${updatedTitle} Participant List`}
            />


            <UploadDetailsTable
                data={data}
                isLoading={isFetching}
                tableParams={params}
                refetch={refetch}
                updateParams={updateParams}
                id={id}

            />
        </>
    )
}

export default UploadListDetails
